import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "preview-area"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "preview-footer"
};
var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 关闭 ");
import { ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    config: {
      type: Object,
      default: function () {
        return {
          visible: false,
          videoUrl: '',
          title: ''
        };
      }
    }
  },
  setup: function (__props) {
    var props = __props;
    var videoRef = ref(null);
    var loading = ref(true);
    var handleOk = function () {
      props.config.visible = false;
    };
    var handleAfterClose = function () {
      props.config.visible = false;
    };
    var onClose = function () {
      if (videoRef.value) {
        videoRef.value.pause();
      }
      props.config.visible = false;
    };
    var onContextMenu = function (ev) {
      ev.preventDefault();
      return false;
    };
    // 监听 videoUrl 变化，重置 loading 状态
    watch(function () {
      return props.config.videoUrl;
    }, function () {
      if (props.config.videoUrl) {
        loading.value = true;
      }
    });
    // 视频可以播放时隐藏 loading
    var onCanPlay = function () {
      loading.value = false;
    };
    // 视频加载中
    var onLoadStart = function () {
      loading.value = true;
    };
    return function (_ctx, _cache) {
      var _component_a_spin = _resolveComponent("a-spin");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: __props.config.visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return __props.config.visible = $event;
        }),
        title: __props.config.title,
        onOk: handleOk,
        onAfterClose: handleAfterClose,
        width: "950px",
        centered: "",
        wrapClassName: "video-intro-modal__question",
        closable: false,
        footer: null,
        maskClosable: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_a_spin, {
            size: "large",
            spinning: loading.value
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [__props.config.videoUrl ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                src: __props.config.videoUrl,
                ref: function (_value, _refs) {
                  _refs['videoRef'] = _value;
                  videoRef.value = _value;
                },
                controls: "",
                controlslist: "nodownload",
                onContextmenu: onContextMenu,
                onCanplay: onCanPlay,
                onLoadstart: onLoadStart
              }, null, 40, _hoisted_2)) : _createCommentVNode("", true)])];
            }),
            _: 1
          }, 8, ["spinning"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
            type: "primary",
            class: "submit",
            onClick: onClose
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          })])])];
        }),
        _: 1
      }, 8, ["visible", "title"]);
    };
  }
});